export const init = ($container) => {
  const dots = $container.querySelectorAll('.c-pathbreaker__dots span');
  const firstCard = $container.querySelector('.c-author-card:first-child');
  const lastCard = $container.querySelector('.c-author-card:last-child');
  const firstObserverOptions = { root: $container, threshold: [0.9] };
  const secondObserverOptions = { root: $container, threshold: [0.9] };

  // flag to avoid second oberver to activate second dot onload
  let isCardScrolled = false;

  const pathbreakerFirstObserver = new IntersectionObserver((entries) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      entries.forEach((entry) => {
        // change value of flag if cards have been scrolled
        if (!isCardScrolled && entry.boundingClientRect.x < 0) {
          isCardScrolled = true;
        }
        dots.forEach((n) => n.classList.remove('active'));
        if (entry.isIntersecting) {
          dots[0].classList.add('active');
        } else {
          dots[1].classList.add('active');
        }
      });
    }
  }, firstObserverOptions);
  const pathbreakerLastObserver = new IntersectionObserver((entries) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      if (isCardScrolled) {
        entries.forEach((entry) => {
          dots.forEach((n) => n.classList.remove('active'));
          if (entry.isIntersecting) {
            dots[2].classList.add('active');
          } else {
            dots[1].classList.add('active');
          }
        });
      }
    } else if (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(max-width: 1023px)').matches) {
      entries.forEach((entry) => {
        dots.forEach((n) => n.classList.remove('active'));
        if (entry.isIntersecting) {
          dots[1].classList.add('active');
        } else {
          dots[0].classList.add('active');
        }
      });
    }
  }, secondObserverOptions);

  pathbreakerFirstObserver.observe(firstCard);
  pathbreakerLastObserver.observe(lastCard);
};
